var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "listos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M54,87.6V100h-8V85.9C48.6,86.7,51.2,87.3,54,87.6z M12.4,46H0v8h14.1C13.3,51.4,12.7,48.8,12.4,46z M60,12 c-15.4,0-28,12.6-28,28s12.6,28,28,28s28-12.6,28-28S75.4,12,60,12 M60,0c22.1,0,40,17.9,40,40S82.1,80,60,80S20,62.1,20,40 S37.9,0,60,0L60,0z M60.9,26L58,27.7l-8.4,4.8l4,6.9l4.4-2.5V54h8V26H60.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon06);
export default __webpack_public_path__ + "static/media/motion_icon-06.83259b40.svg";
export { ForwardRef as ReactComponent };